import React, { useEffect, useState, useRef } from "react";
import styles from "./Home.module.scss";
import { Row, Skeleton, Space } from "antd";
import { encodeBase64, decodeBase64 } from "util/helper";
import TitleAndBreadCrumb from "components/TitleAndBreadCrumb/TitleAndBreadCrumb";
import CardSubject from "components/Card/ExamSet/CardSubject";
import SkelentonCardSubject from "components/Skeleton/Card/SkelentonCardSubject";
import ReactGA from "react-ga";
import { TranslateLanguage } from "util/Translate";
import { vocabHomeSubjectList } from "util/Translate.variable";
import _ from "lodash";
import { SubjectGroupName } from "util/config";
import useComponentDimension from "util/useComponentDimension";
import useWindowSize from "hook/useWindowSize";
import { getSubject } from "api";
import { useDataStore } from "store/DataStoreContext";
import { actionType } from "store/dataReducer";

const translate = new TranslateLanguage();
translate.addMaping(vocabHomeSubjectList);

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ level, history, items, loading, onClickByPublisher }) => {
  const {
    state: { subject, educationType },
    dispatch,
  } = useDataStore();

  const [ref, dimensions] = useComponentDimension();
  const { width } = useWindowSize();

  useEffect(() => {
    fetchSubject();
  }, [educationType.loading]);

  const fetchSubject = async () => {
    if (!educationType.loading && _.isEmpty(subject.data)) {
      await getSubject().then((res) => {
        dispatch({
          type: actionType.FETCH_SUBJECT,
          payload: res,
        });
      });
    }
  };

  const sendGAEvent = (gaEvent) => {
    ReactGA.event(gaEvent);
  };

  const goToSubject = ({ subject: subject, subjectGroup: subjectGroup }) => {
    sendGAEvent({
      category: "Exam",
      action: "Click Card Subject",
      label: subject.name,
    });

    if (history.location.pathname.includes("publisher")) {
      onClickByPublisher(subject.id, subject, subjectGroup);
    } else {
      history.push(`/subject/${subject.id}`, {
        level: level ? level : "ElementarySchool",
        subject: subject,
        subjectGroup: subjectGroup,
      });
    }
  };

  return (
    <React.Fragment>
      {subject.loading ? (
        <>
          <Space>
            <Skeleton.Input
              active={"active"}
              shape={"circle"}
              style={{
                height: "36px",
                marginBottom: "16px",
                marginTop: "8px",
              }}
            />
          </Space>
          <SkelentonCardSubject count={8} />
        </>
      ) : (
        <div style={{ marginTop: "2rem" }}>
          {_.map(
            _.get(
              _.find(subject.data, { id: educationType.activeLevel }),
              "subjectGroupObject"
            ),
            (subjectGroup, i) => {
              return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <TitleAndBreadCrumb
                    title={{
                      text: subjectGroup.name,
                    }}
                  />
                  <div
                    className={styles.divSubject}
                    ref={ref}
                    style={
                      width > 768
                        ? {
                            display: "grid",
                            gridTemplateColumns: "repeat(5, 1fr)",
                            gap: "1rem",
                            alignItems: "start",
                          }
                        : {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gap: "1rem",
                            alignItems: "start",
                          }
                    }
                  >
                    {_.map(subjectGroup.subject, (subject) => {
                      return (
                        <CardSubject
                          key={subject.id}
                          name={subject.name}
                          banner={subject.squareBanner}
                          bannerColorCode={subject.bannerColorCode}
                          info={subject.info}
                          onClick={() =>
                            goToSubject({
                              subject: subject,
                              subjectGroup: subjectGroup.id,
                            })
                          }
                          dimensions={dimensions}
                          comingSoon={subject.comingSoon}
                          subjectGroup={subjectGroup.id}
                          itemId={subject.id}
                          subject={subject}
                          activeLevel={educationType.activeLevel}
                        />
                      );
                    })}
                  </div>
                </div>
              );
            }
          )}
        </div>
      )}
    </React.Fragment>
  );
};
